import { render } from "./SearchResultsTable.vue?vue&type=template&id=f413b784"
import script from "./SearchResultsTable.vue?vue&type=script&lang=js"
export * from "./SearchResultsTable.vue?vue&type=script&lang=js"

import "./SearchResultsTable.vue?vue&type=style&index=0&id=f413b784&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__